import Modifier from 'ember-modifier';

interface GetElementSignature {
  Args: {
    Positional: [handler: (element: HTMLElement) => void];
  };
  Element: HTMLElement;
}

export default class GetElementModifier extends Modifier<GetElementSignature> {
  modify(
    element: GetElementSignature['Element'],
    [handler]: GetElementSignature['Args']['Positional'],
  ): void {
    if (typeof handler === 'function') {
      handler(element);
    }
  }
}
